// Swap地址
import { ZERO_ADDRESS } from '../utils/ethereum';
import { SupportedChainId } from './chains';

export const CHAIN_CURRENCY= {
  [SupportedChainId.MAINNET]:{
    name:'Goerli  ETH',
    symbol: 'ETH',
    decimals: 18,
  },
  [SupportedChainId.GOERLI]:{
    name:'Goerli  ETH',
    symbol: 'ETH',
    decimals: 18,
  },
  [SupportedChainId.ARBITRUM_ONE]:{
    name:'Arbitrum ETH',
    symbol: 'ETH',
    decimals: 18,
  },
  [SupportedChainId.POLYGON]:{
    name:'Matic ETH',
    symbol: 'ETH',
    decimals: 18,
  },
  [SupportedChainId.SEPOLIA]:{
    name:'Sepolia ETH',
    symbol: 'ETH',
    decimals: 18,
  }
};
export const ETH_ADDRESS = ZERO_ADDRESS;

/* GOERLI
MulChainERC20 Address:  0x6308AA4B9b929a61e7Ce8D28497B54A06b251927
ERC20USDTTest Address:  0xE12b5251254Ff698f346Aaf0Af0abF329946550e
tokenRelease Address:  0xd2ac41C448A2963b314Ba32bED5EE6B9c6c33acb
sampleSwapins Address:  0x6A9dC0A204727224DD7B800C1a99b4aEBA736dc0
*/

/*
ERC20USDT:0xB068dcf458413Af88b3b7da7b8AA277DE5030962
PTR:0x3C86A2C1BcEc87995E7E54887ED67CFfba57C20B
const ProxyAdmin="0x61D67aFe2C11dfFd112259E17C5e45F7385dFe5C"
// 代理合约
const Proxyappgroup="0xb2333eaC4efC7cb282713605Ef0C7B16DAD7fA71"
const Proxyuser="0x4A965038efEbbfD558ae6a1FEEBb152F2FC549C6"
const ProxycpNode="0x6b51CFF5c74E2F1dFc9C6F346Ca934F6dD54278B"
const ProxywgNode="0x25241E45f5DE6A2e8BD697c2EF2B2c4e214B0544"
const ProxyvalidNode="0xAD7589e8Af482b44962A0585D8170E5805B6B831"
const ProxyRecord="0xC707237BC6Dd762db3Df00836315B75251B2bE58"
const ProxyShare="0xBa5aC76B77873937A02B4104B48AC8a5482f8aD3"
*/

// ERC20币 或 原生币
export const TOKEN_ADDRESS = {
  [SupportedChainId.SEPOLIA]:'0x3C86A2C1BcEc87995E7E54887ED67CFfba57C20B',
  [SupportedChainId.GOERLI]:'0x34F919a86F8cE688bFc54f0025adE78DEa41DFF8',
  [SupportedChainId.ARBITRUM_ONE]:'0x6308AA4B9b929a61e7Ce8D28497B54A06b251927',
  [SupportedChainId.POLYGON]:'0x6308AA4B9b929a61e7Ce8D28497B54A06b251927',
}


// USDT合约地址
export const USDT_ADDRESS = {
  [SupportedChainId.SEPOLIA]:'0xB068dcf458413Af88b3b7da7b8AA277DE5030962',
  [SupportedChainId.GOERLI]:'0x3f9b96aCF1860729BE9575F171C5D2c6F549B50E',
  [SupportedChainId.ARBITRUM_ONE]:'0xE12b5251254Ff698f346Aaf0Af0abF329946550e',
  [SupportedChainId.POLYGON]:'0xE12b5251254Ff698f346Aaf0Af0abF329946550e',
}

 // 应用类型
 export const GROUPAPP_ADDRESS = {
  [SupportedChainId.SEPOLIA]:'0xb2333eaC4efC7cb282713605Ef0C7B16DAD7fA71',
  [SupportedChainId.GOERLI]:'0xd5b0A122a4075C349566B68392F2811e568b9F7a',
  [SupportedChainId.ARBITRUM_ONE]:'0xd5b0A122a4075C349566B68392F2811e568b9F7a',
  [SupportedChainId.POLYGON]:'0xd5b0A122a4075C349566B68392F2811e568b9F7a',
}


// 网关节点合约地址
export const WGNODES_ADDRESS = {
  [SupportedChainId.SEPOLIA]:'0x25241E45f5DE6A2e8BD697c2EF2B2c4e214B0544',
  [SupportedChainId.GOERLI]:'0x33EAE3072Cb57aB7B1a8DffF4BF4F8EBE83859AA',
  [SupportedChainId.ARBITRUM_ONE]:'0x33EAE3072Cb57aB7B1a8DffF4BF4F8EBE83859AA',
  [SupportedChainId.POLYGON]:'0x33EAE3072Cb57aB7B1a8DffF4BF4F8EBE83859AA',
}

// 服务节点合约地址
export const CPNODES_ADDRESS = {
  [SupportedChainId.SEPOLIA]:'0x6b51CFF5c74E2F1dFc9C6F346Ca934F6dD54278B',
  [SupportedChainId.GOERLI]:'0x37Aea4977e9DFE461FeBFB4dD3E09E2b7ADE9cef',
  [SupportedChainId.ARBITRUM_ONE]:'0x37Aea4977e9DFE461FeBFB4dD3E09E2b7ADE9cef',
  [SupportedChainId.POLYGON]:'0x37Aea4977e9DFE461FeBFB4dD3E09E2b7ADE9cef',
}
// 验证节点合约地址
export const VILDNODES_ADDRESS = {
  [SupportedChainId.SEPOLIA]:'0xAD7589e8Af482b44962A0585D8170E5805B6B831',
  [SupportedChainId.GOERLI]:'0x4dB2486ef961A8d4e7CEd9740Eb10E27493EB34F',
  [SupportedChainId.ARBITRUM_ONE]:'0x4dB2486ef961A8d4e7CEd9740Eb10E27493EB34F',
  [SupportedChainId.POLYGON]:'0x4dB2486ef961A8d4e7CEd9740Eb10E27493EB34F',
}


// 用户合约地址
export const USERS_ADDRESS = {
  [SupportedChainId.SEPOLIA]:'0x4A965038efEbbfD558ae6a1FEEBb152F2FC549C6',
  [SupportedChainId.GOERLI]:'0x7979AEF7f981E5CE5F2703442075C7bA028Cb440',
  [SupportedChainId.ARBITRUM_ONE]:'0x7979AEF7f981E5CE5F2703442075C7bA028Cb440',
  [SupportedChainId.POLYGON]:'0x7979AEF7f981E5CE5F2703442075C7bA028Cb440',
}


// 用户分享收益
export const USERS_SHARE = {
  [SupportedChainId.SEPOLIA]:'0xBa5aC76B77873937A02B4104B48AC8a5482f8aD3',
  [SupportedChainId.GOERLI]:'0x4d0Ea290AB39cb967490f24204c731e0f1B6e63f',
  [SupportedChainId.ARBITRUM_ONE]:'0x4d0Ea290AB39cb967490f24204c731e0f1B6e63f',
  [SupportedChainId.POLYGON]:'0x4d0Ea290AB39cb967490f24204c731e0f1B6e63f',
}


// 节点服务记录和奖励
export const NODE_RECORD = {
  [SupportedChainId.SEPOLIA]:'0xC707237BC6Dd762db3Df00836315B75251B2bE58',
  [SupportedChainId.GOERLI]:'0xaa749cCfEe2D4Fe10451b418970fB5BeA80975d0',
  [SupportedChainId.ARBITRUM_ONE]:'0xaa749cCfEe2D4Fe10451b418970fB5BeA80975d0',
  [SupportedChainId.POLYGON]:'0xaa749cCfEe2D4Fe10451b418970fB5BeA80975d0',
}

// 锁仓合约地址
export const LOCKED_ADDRESS = {
  [SupportedChainId.SEPOLIA]:'0x34F919a86F8cE688bFc54f0025adE78DEa41DFF8',
  [SupportedChainId.GOERLI]:'0x8082D4D162f3D0608d1B6bc0Ba953d74dEC1444f',
  [SupportedChainId.ARBITRUM_ONE]:'0x8082D4D162f3D0608d1B6bc0Ba953d74dEC1444f',
  [SupportedChainId.POLYGON]:'0x8082D4D162f3D0608d1B6bc0Ba953d74dEC1444f',
}
 // 大额锁仓购买地址
 export const LOCKEDSWAP_ADDRESS = {
  [SupportedChainId.SEPOLIA]:'0x34F919a86F8cE688bFc54f0025adE78DEa41DFF8',
  [SupportedChainId.GOERLI]:'0x27F40476AF5feAd0408eF2A0b5FD29D0d986F536',
  [SupportedChainId.ARBITRUM_ONE]:'0x27F40476AF5feAd0408eF2A0b5FD29D0d986F536',
  [SupportedChainId.POLYGON]:'0x27F40476AF5feAd0408eF2A0b5FD29D0d986F536',
}


// 交换合约
export const SIMPLESAWP_ADDRESS = {
  [SupportedChainId.SEPOLIA]:'0x34F919a86F8cE688bFc54f0025adE78DEa41DFF8',
  [SupportedChainId.GOERLI]:'0xB5F9380a873F43b74305CAF67a8323cB8f383D19',
  [SupportedChainId.ARBITRUM_ONE]:'0x6A9dC0A204727224DD7B800C1a99b4aEBA736dc0',
  [SupportedChainId.POLYGON]:'0x6A9dC0A204727224DD7B800C1a99b4aEBA736dc0',
}






export const ETH_TOKEN_ADDRESS = '0x2170Ed0880ac9A755fd29B2688956BD959F933F8';
export const MINI_SWAP_ADDRESS = '0x4c13Ee9EB6B7623b8dA9F77BB049367b1C386641';                    
export const MINI_POOL_ADDRESS = '0x76154A579a573343ee41Fd3e23C53adE46F75c7a';
export const MINI_REGISTER_ADDRESS='0x08b65e47f90F4e7650C4d45513CBE4e458Bbb064';


